import { connect, IAdFoxBannerOnErrorError } from '@cian/adfox-component';
import { withAdfoxPostViewAnalytics } from '@cian/postview-analytics-utils';
import * as React from 'react';
import { useApplicationContext } from 'shared/map-search/containers/ApplicationContext';

import { useAdfoxContext } from '../../context/AdfoxContext';
import { OwnTemplates } from '../templates/OwnTemplates';

const AdfoxBannerConnected = connect(OwnTemplates);

export interface IAdfoxBannerProps {
  onStub?(): void;
  onError?(error: IAdFoxBannerOnErrorError): void;
}

export const AdfoxBanner = React.memo<IAdfoxBannerProps>(function AdfoxBanner(props) {
  const { onStub, onError } = props;
  const { params, size, postViewAnalyticsData } = useAdfoxContext();
  const { logger } = useApplicationContext();

  const [isHidden, setIsHidden] = React.useState<boolean>(false);

  const handleStub = React.useCallback<VoidFunction>(() => {
    setIsHidden(true);
    onStub?.();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleError = React.useCallback<(error: IAdFoxBannerOnErrorError) => void>(error => {
    setIsHidden(true);
    onError?.(error);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   * HOC создаёт новый React-класс на каждый вызов, поэтому фиксируем его через useMemo.
   * Без мемоизации каждый ре-рендер родителя пересоздаёт тип → React делает unmount+mount →
   * Ya.adfoxCode.destroy стреляет раньше, чем yaContextCb успевает вызвать create → запрос не уходит.
   */
  return React.useMemo(() => {
    if (isHidden) {
      return null;
    }

    const Banner = withAdfoxPostViewAnalytics(AdfoxBannerConnected, postViewAnalyticsData, { logger });

    return <Banner params={params} width={size.width} height={size.height} onStub={handleStub} onError={handleError} />;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isHidden]);
});
